/* Preserve the original HD hover photo URLs; touch devices need only the
   product packshot. Desktop/focus preloads near the card, before interaction. */
(function () {
  var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var images = Array.from(document.querySelectorAll('img[data-earthle-hover-src]'));
  function load(img) {
    var src = img.getAttribute('data-earthle-hover-src');
    if (!src) return;
    var srcset = img.getAttribute('data-earthle-hover-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.src = src;
    img.removeAttribute('data-earthle-hover-src');
    img.removeAttribute('data-earthle-hover-srcset');
  }
  var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    if (!hover.matches) return;
    entries.forEach(function (entry) { if (entry.isIntersecting) load(entry.target); });
  }, { rootMargin: '120px 0px' }) : null;
  function setup() {
    if (!hover.matches) return;
    images.forEach(function (img) { if (observer) observer.observe(img); else load(img); });
  }
  images.forEach(function (img) {
    var card = img.closest('a');
    if (!card) return;
    card.addEventListener('pointerenter', function () { if (hover.matches) load(img); }, { passive: true });
    card.addEventListener('focusin', function () { if (card.matches(':focus-visible')) load(img); });
  });
  if (hover.addEventListener) hover.addEventListener('change', setup);
  setup();

})();
